import { gql } from '@apollo/client'

export const LoginWithGoogle = gql`
    mutation LoginWithGoogle($idToken: String!) {
        loginWithGoogle(idToken: $idToken) {
            user {
                id
                created
                email
                invites {
                    id
                    issuer {
                        id
                        username
                    }
                    room {
                        id
                        name
                        owner {
                            id
                            username
                        }
                    }
                }
                rooms {
                    id
                    name
                    topic
                    spinning
                    admins {
                        id
                        username
                    }
                    members {
                        id
                        username
                    }
                }
                roles
                updated
                username
            }
            refreshToken
            accessToken
        }
    }
`

export default LoginWithGoogle

